import {LiveCasinoGridItemDefaultBox} from "./live-casino-grid-item.default.box";

export const LiveCasinoGridItemBox = LiveCasinoGridItemDefaultBox;